<template>
  <div>
    <div class="loan-container">
      <h4 class="header">Loans</h4>
      <p class="subText">Manage all loans here</p>

      <div class="loan-container__header-container">
        <div class="loan-container__header-card">
          <h4 class="header">Overview</h4>
          <p class="subText">Here’s a quick overview of what’s happening</p>

          <div class="inner-border">
            <div class="inner-border__container">
              <div class="border-right">
                <div class="border-bottom border-padding-right">
                  <p>Total Loans</p>

                  <h4>
                    ₦
                    {{
                      loanSummary &&
                        new Intl.NumberFormat().format(
                          Number(loanSummary.totalLoansAmount || 0)
                        )
                    }}
                  </h4>

                  <p>This month</p>
                </div>
              </div>

              <div>
                <div class="border-bottom border-padding-left">
                  <p class="red-text">OVERDUE LOANS</p>

                  <h4>
                    ₦
                    {{
                      loanSummary &&
                        new Intl.NumberFormat().format(
                          Number(loanSummary.totalOverdueLoanAmount || 0)
                        )
                    }}
                  </h4>

                  <p>This month</p>
                </div>
              </div>
              <div class="border-right">
                <div class="border-padding-right">
                  <p class="blue-text">APPROVED LOANS</p>

                  <h4>
                    ₦
                    {{
                      loanSummary &&
                        new Intl.NumberFormat().format(
                          Number(loanSummary.totalApprovedLoansAmount || 0)
                        )
                    }}
                  </h4>

                  <p>This month</p>
                </div>
              </div>

              <div>
                <div class="border-padding-left ">
                  <p class="green-text">CLOSED LOANS</p>

                  <h4>
                    ₦
                    {{
                      loanSummary &&
                        new Intl.NumberFormat().format(
                          Number(loanSummary.totalClosedLoansAmount || 0)
                        )
                    }}
                  </h4>

                  <p>This month</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="loan-container__header-card">
          <h4 class="header">Top Insights</h4>

          <div class="inner-border">
            <div class="insight-container">
              <img
                src="../../assets/images/green-chart.svg"
                class="img-fluid identification__image"
                alt
              />

              <div>
                <h4>
                  {{ (loanSummary && loanSummary.activeBorrowers) || 0 }}
                </h4>
                <p>Active Borrowers</p>
              </div>
            </div>
          </div>
          <div class="inner-border">
            <div class="insight-container">
              <img
                src="../../assets/images/blue-chart.svg"
                class="img-fluid identification__image"
                alt
              />

              <div>
                <h4>
                  ₦
                  {{
                    loanSummary &&
                      new Intl.NumberFormat().format(
                        Number(loanSummary.totalDisbursedLoansAmount || 0)
                      )
                  }}
                </h4>
                <p>Total Disbursed Loans</p>
              </div>
            </div>
          </div>
          <div class="inner-border">
            <div class="insight-container">
              <img
                src="../../assets/images/orange-chart.svg"
                class="img-fluid identification__image"
                alt
              />

              <div>
                <h4>
                  {{
                    (loanSummary && loanSummary.totalNumberOfPaidLoans) || 0
                  }}/{{
                    (loanSummary && loanSummary.totalNumberOfUnpaidLoans) || 0
                  }}
                </h4>
                <p>Fully Paid Loans vs Unpaid Loans</p>
              </div>
            </div>
          </div>

          <div class="inner-border">
            <div class="insight-container">
              <img
                src="../../assets/images/red-chart.svg"
                class="img-fluid identification__image"
                alt
              />

              <div>
                <h4>0</h4>
                <p>Total Penalty Fees</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h4 class="list-loans-header">All loans</h4>
      <p class="list-loans-subText">
        Get insights into all of your loan activities, from active loans to
        repaid loans.
      </p>

      <div class="loan-container__header-card">
        <div class="list-of-loans-table-container">
          <table class="list-of-loans-table">
            <thead>
              <tr>
                <th class="list-of-loans-table-heading">
                  ID
                </th>
                <th class="list-of-loans-table-heading">
                  BORROWER
                </th>
                <th class="list-of-loans-table-heading">
                  PRINCIPAL AMOUNT
                </th>
                <th class="list-of-loans-table-heading">
                  TENURE
                </th>
                <th class="list-of-loans-table-heading">
                  TIME STAMP
                </th>
                <th class="list-of-loans-table-heading">
                  STATUS
                </th>
                <th class="list-of-loans-table-heading">
                  ACTION
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(loan, index) in listOfLoans" :key="index">
                <td class="list-of-loans-table-data">
                  {{ loan && loan.trackingCode }}
                </td>
                <td class="list-of-loans-table-data">
                  {{ loan && loan.user }}
                </td>
                <td class="list-of-loans-table-data">
                  ₦
                  {{
                    loan &&
                      new Intl.NumberFormat().format(
                        Number(loan.requestedAmount)
                      )
                  }}
                </td>
                <td class="list-of-loans-table-data">
                  {{ loan && loan.tenure }}
                </td>
                <td class="list-of-loans-table-data">
                  {{ loan && loan.createdAt | formatDate }}
                </td>
                <td class="list-of-loans-table-data">
                  <StatusBadge :status="loan && loan.status" />
                </td>
                <td class="list-of-loans-table-data">
                  <b-dropdown
                    id="dropdown-right"
                    right
                    size="lg"
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                  >
                    <template v-slot:button-content>
                      <svgicon
                        icon="table-menu"
                        class="dashboard__listing-table-menu"
                      ></svgicon>
                    </template>
                    <b-dropdown-item :to="`/loan-details/${loan.id}`"
                      >View</b-dropdown-item
                    >
                  </b-dropdown>
                </td>
              </tr>
            </tbody>
          </table>

          <div
            class="dashboard__pagination"
            v-if="listOfLoans && listOfLoans.length > 0"
          >
            <b-pagination
              pills
              v-model="currentPage"
              :total-rows="totalLoans"
              :per-page="pageSize"
              prev-text="Prev"
              next-text="Next"
              first-number
              last-number
              @change="handlePagination"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <loader :loader="loader"></loader>
  </div>
</template>
<script>
import loader from "../resuables/loader";
import StatusBadge from "../general/statusBadge.vue";
import { getAllLoans, getAllLoanAmountSummary } from "../../../services/loans";
export default {
  name: "loans",
  components: {
    loader,
    StatusBadge
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      count: 0,
      pages: 0,
      loader: false,
      totalLoans: 0,
      listOfLoans: [],
      loanSummary: {}
    };
  },
  watch: {
    $route() {
      this.handleAllLoans();
    }
  },
  methods: {
    handleGetLoanSummary() {
      getAllLoanAmountSummary()
        .then(res => {
          this.loanSummary = res.data;
        })
        .catch(err => {
          return err;
        });
    },

    handlePagination(value) {
      if (value === 1) {
        this.pages = 0;
      } else {
        this.pages = (value - 1) * this.pageSize;
      }
      this.currentPage = value;
      this.$router.push({ query: { page: value } });
    },

    handleAllLoans() {
      this.loader = true;
      const payload = {
        page: this.currentPage,
        limit: this.pageSize
      };
      getAllLoans(payload)
        .then(res => {
          this.listOfLoans = res.data.loans;
          this.totalLoans = res.data.totalLoan;
        })
        .catch(err => {
          return err;
        })
        .finally(() => {
          this.loader = false;
        });
    }
  },
  async mounted() {
    this.currentPage = this.$route.query.page || 1;
    await Promise.all([this.handleAllLoans(), this.handleGetLoanSummary()]);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/loans.vue